<template>
  <section>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="150"
    >
      <Card :bordered="false" dis-hover>
        <Form-item label="">
          <div class="select-container">
            <div class="chose-input" @click="visiable = true">
              <div class="chose-item" v-if="selectCheckbox.name">
                {{ selectCheckbox.name }}
                <Icon
                  type="md-remove-circle"
                  color="wdite"
                  style="margin-left: 10px"
                  @click="removeSelectCheck"
                />
              </div>
            </div>
            <Button
              type="primary"
              style="margin-left: -5px; height: 48px"
              icon="ios-search"
              @click="visiable = true"
              >选择商品</Button
            >
          </div>
        </Form-item>
        <Form-item label="添加人" prop="addOptUser">
          <Input
            v-model="formValidate.addOptUser"
            placeholder="请输入添加人"
            style="width: 500px"
          ></Input>
        </Form-item>
        <Form-item label="认证类型" prop="skuRuleType">
          <RadioGroup v-model="formValidate.skuRuleType">
            <Radio label="0">
              <span>全部经销商</span>
            </Radio>
            <Radio label="1">
              <span>部分经销商</span>
            </Radio>
          </RadioGroup>
        </Form-item>
        <div v-if="formValidate.skuRuleType == '1'" style="width: 900px">
          <Form-item>
            <Table
              :loading="loading"
              border
              :columns="columns"
              :data="spInfoQueryList"
              ref="table"
              @on-selection-change="selectionChange"
            ></Table>

            <Row
              type="flex"
              justify="end"
              class="page"
              style="margin-top: 10px"
            >
              <Page
                :current="searchValidate.page"
                :total="total"
                :page-size="searchValidate.pageSize"
                @on-change="changePage"
                @on-page-size-change="changePageSize"
                :page-size-opts="[10, 20, 50]"
                size="small"
                show-total
                show-elevator
                show-sizer
              >
              </Page>
            </Row>
          </Form-item>
        </div>

        <FormItem style="margin-left: 15px" class="br">
          <Button @click="handleSave" type="primary" icon="ios-search"
            >保存</Button
          >
          <Button @click="handleReset" style="margin-left: 10px">取消</Button>
        </FormItem>
      </Card>
    </Form>
    <div v-if="visiable">
      <Modal title="添加商品" v-model="visiable" width="900">
        <sku-form
          :handleSelectCheck="handleSelectCheck"
          :skuCode="formValidate.skuCode"
        ></sku-form>
      </Modal>
    </div>
  </section>
</template>

<script>
const initFormValidate = {
  page: 1,
  pageSize: 10,
  skuRuleType: "",
  skuCode: "",
  addOptUser: "",
};

import skuForm from "./components/skuForm";
export default {
  name: "skuSpEdit",
  components: {
    skuForm,
  },
  data() {
    const { id } = this.$route.query;
    return {
      id: id,
      total: 0,
      visiable: false,
      loading: false,
      dataSource: [],
      selectTable: [],
      ruleDetail: [],
      spInfoQueryList: [],
      selectCheckbox: {},
      searchValidate: {
        page: 1,
        pageSize: 10,
      },
      formValidate: initFormValidate,
      ruleValidate: {
        skuRuleType: [{ required: true, message: "请选择认证类型" }],
      },
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "经销商名称",
          key: "name",
          minWidth: 200,
          align: "center",
        },
        {
          title: "级别",
          key: "dealerLevel",
          minWidth: 120,
          align: "center",
        },
        {
          title: "关联运营方",
          key: "parentCode",
          minWidth: 150,
          align: "center",
        },
        {
          title: "手机号",
          key: "contactMobile",
          minWidth: 120,
          align: "center",
        },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      await this.getSkuRuleQueryDetail();
      await this.getSpInfoQueryAll(this.searchValidate);
    },
    async getSpInfoQueryAll(params = {}) {
      const { data, total } = await this.$api["spInfoQueryAll"](params);

      if (this.ruleDetail.length > 0) {
        const checkedData = data.reduce((prev, cuur) => {
          return prev.concat(
            this.ruleDetail.includes(cuur.code)
              ? { ...cuur, _checked: true }
              : cuur
          );
        }, []);
        this.spInfoQueryList = checkedData;
      } else {
        this.spInfoQueryList = data;
        this.total = total;
      }
    },
    async getSkuRuleQueryDetail() {
      if (!this.id) {
        this.formValidate.skuRuleType = "";
        this.formValidate.skuCode = "";
        this.formValidate.addOptUser = "";
        this.ruleDetail = [];
        return false;
      } else {
        const params = {
          id: this.id,
        };
        const { data } = await this.$api["skuRuleQueryDetail"](params);
        this.formValidate.skuRuleType = data.ruleType;
        this.formValidate.skuCode = data.skuCode;
        this.formValidate.addOptUser = data.addOptUser;
        this.ruleDetail = data.ruleDetail ? JSON.parse(data.ruleDetail) : [];
        this.searchProductSku(data.skuCode);
      }
    },
    async searchProductSku(code) {
      const params = {
        skuCode: code,
      };
      const { data } = await this.$api.skuDetail(params);
      this.selectCheckbox = data;
    },
    changePage(v) {
      this.searchValidate.page = v;
      this.getSpInfoQueryAll(this.searchValidate);
    },
    changePageSize(v) {
      this.searchValidate.pageSize = v;
      this.getSpInfoQueryAll(this.searchValidate);
    },
    async handleSave() {
      if (!this.selectCheckbox.code) {
        this.$Message.error("请先选择一个商品");
        return false;
      }
      const info = this.formValidate;
      const params = {
        skuRuleType: info.skuRuleType,
        skuCode: this.selectCheckbox.code,
        addOptUser: info.addOptUser,
      };

      if (this.id) {
        params["id"] = this.id;
      }

      if (params.skuRuleType != "0") {
        params.ruleDetail = this.switchSelectTable(this.selectTable);
      }

      const { data, code } = this.id
        ? await this.$api["skuSpUpload"](params)
        : await this.$api["skuSpAdd"](params);
      if (code == "200") {
        this.$refs["formValidate"].resetFields();
        this.formValidate = initFormValidate;
        this.$router.back();
      }
    },
    switchSelectTable(v) {
      if (v.length == 0) return [];
      return v.map((item) => item.code);
    },
    handleReset() {
      this.$refs["formValidate"].resetFields();
      this.formValidate = initFormValidate;
      this.$router.back();
    },
    selectionChange(v) {
      this.selectTable = v;
    },
    handleSelectCheck(v) {
      this.selectCheckbox = v;
      this.formValidate.skuCode=v.code;
    },
    removeSelectCheck(e) {
      e.stopPropagation();
      this.selectCheckbox = {};
    },
  },
};
</script>

<style>
.select-container {
  display: flex;
  align-items: center;
}
.chose-input {
  width: 500px;
  height: 48px;
  border: 1px solid #5586ff;
  border-radius: 5px;
  padding: 8px;
}
.chose-item {
  display: inline-block;
  width: auto;
  height: 32px;
  background: #5586ff;
  border-radius: 5px;
  padding: 0 8px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/commodity/skuSpEdit.vue